import { isEmpty } from 'lodash';
import { RawSearchResults } from './RawSearchResults';

export const isRawSearchResult = (data: any): data is RawSearchResults => !isEmpty(data) && 'gigs' in data;
